import { render } from "./PublicationsCreatev2.vue?vue&type=template&id=45cbccdc"
import script from "./PublicationsCreatev2.vue?vue&type=script&lang=js"
export * from "./PublicationsCreatev2.vue?vue&type=script&lang=js"

import "./PublicationsCreatev2.vue?vue&type=style&index=0&id=45cbccdc&lang=scss"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__